// imports...

const state = {
    display: 'none',
    isNotification: false,
    title: '',
    message: '',
    buttons: '',
    specialClassNames: '',
    duration: 0,
    displayCloseIcon: false,
    background: false
}

const getters = {
    getOverlayDisplay: state => state.display,
    getTitle: state => state.title,
    getType: state => state.type,
    getMessage: state => state.message,
    getSpecialClassNames: state => state.specialClassNames,
    getButtons: state => state.buttons,
    getDuration: state => state.duration,
    getIsNotification: state => state.isNotification,
    getDisplayCloseIcon: state => state.displayCloseIcon,
    getBackground: state => state.background
}

const actions = {
    // data is either none or block :: css display of the modal.
    async triggerOverlay({commit}, data){
        commit('triggerOverlay', data);
    },
    updateOverlayParams({commit},model){
        console.log('overlay data update in progress...', model)
        commit('setTitle',model.title)
        commit('setType',model.type)
        commit('setMessage',model.message)
        commit('setSpecialClassNames',model.specialClassNames)
        commit('setButtons',model.buttons)
        commit('setDuration',model.duration)
        commit('setIsNotification',model.isNotification)
        commit('setButtons',model.buttons)
        commit('setDisplayCloseIcon',model.displayCloseIcon)
        commit('triggerOverlay', model.display);
        commit('setBackground', model.background);
    },
    resetOverlay({commit, dispatch}) {
        dispatch('updateOverlayParams', {
            display: 'none',
            isNotification: false,
            type: '',
            title: '',
            message: '',
            buttons: '',
            specialClassNames: '',
            duration: 0,
            displayCloseIcon: false,
            background: false
        });
    }
}

const mutations = {
    triggerOverlay: (state, data) => {
        state.display = ((d) => {
            if (d === false) {
                return 'none';
            }
            if (d === true) {
                return 'block';
            }
            return d;
        })(data);
    },
    setTitle: (state, data) => {
        state.title = data;
    },
    setType: (state, data) => {
        state.type = data;
    },
    setBackground: (state, data) => {
        state.background = data;
    },
    setMessage: (state, data) => {
        state.message = data;
    },
    setSpecialClassNames: (state, data) => {
        state.specialClassNames = data;
    },
    setButtons: (state, data) => {
        state.buttons = data;
    },
    setDuration: (state, data) => {
        state.duration = data;
    },
    setIsNotification: (state, data) => {
        state.isNotification = data;
    },
    setDisplayCloseIcon: (state, data) => {
        state.displayCloseIcon = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}